export default __webpack_public_path__ + "static/Fax-machine-sound-e595a143d7d99578a6a7071cc68f4d09.mp3";